import {
    SET_CURRENT_USER,
    SET_LANG,
    SET_META_DATA,
    SET_USER_REQUEST,
    SET_ROLE_ID,
    SET_CITIES,
    SET_CURRENT_CLIENT,
    NOTIFICATION_LIST,
    SET_GOVERNATES,
  
    // Add these:
    SET_META_DATA_INDIVIDUAL,
    SET_CUSTOMER_ADDRESSES,
    SET_SERVICES_DATA,
    SET_FAQ_CATEGORIES,
    SET_SETTINGS,
    SET_TERMS_AND_CONDITIONS_PAGES,
    SET_COUNTRIES,
    SET_LOADING
  } from "./user.type";
  
  const INITIAL_STATE = {
      currentUser : null,
      metaData : null,
      userRequest : null,
      currentClient : null,
      currentLang : "en",
      governoratesList : [],
      citiesList : [],
      notificationList : [],
      roleId: null,
  
      // Old keys:
      metaDataIndividual: null,
      userAddress: [],
      servicesList: null,
      FAQCategories: null,
      Settings: null,
      termsAndConditionsPages: null,
      Countries: [],
      loading: false
  }
  
  const userReducer = (state = INITIAL_STATE, action) => {
      switch (action.type) {
          case SET_CURRENT_USER:
              return { ...state, currentUser : action.payload }
          case SET_CURRENT_CLIENT:
              return { ...state, currentClient :  {...action.payload} }
          case SET_META_DATA:
              return { ...state, metaData :  {...action.payload} }
          case SET_USER_REQUEST:
              return { ...state, userRequest :  {...action.payload} }
          case SET_LANG:
              return { ...state, currentLang :action.payload }
          case SET_CITIES:
              return { ...state, citiesList :action.payload }
          case SET_GOVERNATES:
              return { ...state, governoratesList :action.payload }
          case SET_ROLE_ID:
              return { ...state, roleId :action.payload }
          case NOTIFICATION_LIST:
              return { ...state, notificationList :action.payload }
  
          // Added from old
          case SET_META_DATA_INDIVIDUAL:
              // action.payload = { type, data }
              return {
                  ...state,
                  metaDataIndividual: { [action.payload.type]: action.payload.data }
              }
          case SET_CUSTOMER_ADDRESSES:
              return { ...state, userAddress: action.payload }
          case SET_SERVICES_DATA:
              return { ...state, servicesList: action.payload }
          case SET_FAQ_CATEGORIES:
              return { ...state, FAQCategories: action.payload }
          case SET_SETTINGS:
              return { ...state, Settings: action.payload }
          case SET_TERMS_AND_CONDITIONS_PAGES:
              return { ...state, termsAndConditionsPages: action.payload }
          case SET_COUNTRIES:
              return { ...state, Countries: action.payload }
          case SET_LOADING:
              return { ...state, loading: action.payload }
          default:
              return state;
      }
  }
  
  export default userReducer;
  